import {html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {unsafeHTML} from 'lit/directives/unsafe-html.js';
import Decimal from './break_infinity.js';
import {Cost, DynamicCost} from './interfaces/dynamic-value.js';
import {LogEntry} from './log';
import {ri} from './runner-idle.js';
import {formatEng, formatTime} from './utils.js';

@customElement('ri-activity-log-entry')
export class ActivityLogEntry extends LogEntry {
  cost: Cost = new Map();
  effect: Cost = new Map();
  name = '';
  override important = false;
  displayName = '';
  logString = '';

  public add(data: {cost: Cost; effect: Cost}) {
    this.duration += 1;
    const {cost, effect} = data;
    for (const [key, {value, string: str}] of cost) {
      if (this.cost.has(key)) {
        const {value: oldValue, string: oldString} = this.cost.get(key)!;
        this.cost.set(key, {
          value: new Decimal(oldValue).add(value),
          string: `${oldString} + ${str}`,
        });
      } else {
        this.cost.set(key, {value, string: str});
      }
    }
    for (const [key, {value, string: str}] of effect) {
      if (this.effect.has(key)) {
        const {value: oldValue, string: oldString} = this.effect.get(key)!;
        this.effect.set(key, {
          value: new Decimal(oldValue).add(value),
          string: `${oldString} + ${str}`,
        });
      } else {
        this.effect.set(key, {value, string: str});
      }
    }
    this.requestUpdate();
  }
  override render() {
    setTimeout(() => this.scrollIntoView());
    return html`<div class="container">
      <div class="header">
        ${`${this.life > 0 ? `${this.life}-` : ''} ${formatTime(
          this.tick,
          true
        )} -`}
      </div>
      <div class="msg">
        <span class="fancy ${this.name}"
          >${this.displayName}${this.duration > 1
            ? ` x${this.duration}`
            : ''}</span
        >
        ${this.logString}<span class="effect"
          >${unsafeHTML(
            [...this.effect]
              .filter(
                ([k, {value}]) =>
                  !new Decimal(value).eq(0) && ri?.get(k)?.unlocked
              )
              .map(
                ([k, v]) =>
                  `<span class='fancy ${k}'>${formatEng(v.value)}</span> ${
                    ri?.get(k)?.displayName
                  }`
              )
              .join(', ')
          )}</span
        ><span class="expand"></span>${this.cost.size > 0
          ? unsafeHTML(
              `${[...this.cost]
                .filter(
                  ([k, {value}]) =>
                    new Decimal(value).gt(0) && ri?.get(k)?.unlocked
                )
                .map(
                  ([k, v]) =>
                    `<span class='fancy ${k}'>-${formatEng(v.value)}</span> ${
                      ri?.get(k)?.displayName
                    }`
                )
                .join(', ')}`
            )
          : ''}
      </div>
    </div>`;
  }
}
